// removed by extract-text-webpack-plugin
module.exports = {"counting-box":"app-pages-AccountSetting-Receipt-ReceiptPreview-__ReceiptPreview___zdxP1","wrapper":"app-pages-AccountSetting-Receipt-ReceiptPreview-__ReceiptPreview___2D22H","receipt":"app-pages-AccountSetting-Receipt-ReceiptPreview-__ReceiptPreview___JYSRZ"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/AccountSetting/Receipt/ReceiptPreview/ReceiptPreview.css
// module id = 2058
// module chunks = 0